module.exports = __webpack_public_path__ + "img/deco-bg-right.09b3b416.svg";